import React from 'react';
import { Button, Typography } from '~/UIKit';
import { TFunction } from 'i18next';
import { makeStyles } from '~/UIKit/Style';

type PasswordResetSuccessComponentProps = {
  t: TFunction;
  handleBackToLogin: () => void;
};

const useStyles = makeStyles((theme) => ({
  title: {
    marginBottom: theme.spacing(4),
    wordBreak: 'break-word',
    whitespace: 'pre',
  },
  button: {
    margin: '30px 0',
  },
}));

const PasswordResetSuccesComponent = ({
  t,
  handleBackToLogin,
}: PasswordResetSuccessComponentProps) => {
  const { classes } = useStyles();

  return (
    <>
      <Typography className={classes.title} data-testid="passwordSuccessMessage" variant="h4">
        {t('app.newpassword.success')}
      </Typography>
      <Button
        className={classes.button}
        color="primary"
        data-testid="passwordSuccessBackToLoginBtn"
        fullWidth
        onClick={handleBackToLogin}
        variant="contained"
      >
        {t('app.backToLogin')}
      </Button>
    </>
  );
};

export default PasswordResetSuccesComponent;
